<template>
  <div class="bg-pdsPrimaryColor px-16">
    <div class="border-t border-indigo-200 border-opacity-25"></div>
  </div>
  <header class="bg-pdsPrimaryColor pt-10 pb-32">
    <div class="mx-auto w-10/12">
      <h1 class="text-2xl font-bold tracking-tight text-white m-0 pl-1">
        <slot name="title" />
      </h1>
    </div>
  </header>
</template>
<script>
export default {
  name: 'PageHeader',
  setup() {
    return {};
  }
};
</script>
